import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../Components/ProgressBar';
import NavigationButtons from '../Components/NavigationButtons';
import Navbar from '../Components/Navbar';
import SurveyQuestion from '../Components/SurveyQuestion';  // Import the new component
import { Box, Text } from '@chakra-ui/react';
import axios from 'axios';
import { useAuth } from '../Components/auth/AuthProvider';

const SurveyPage3 = ({ surveyData, setSurveyData }) => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const [formData, setFormData] = useState(surveyData || {});
  const navigate = useNavigate();
  const {token, user} = useAuth();

  const handleNext = () => {
    console.log(user)
    const updatedFormData = {
      ...formData,
      student_id: Number(user) // Make sure `user` contains the relevant user data
    };
    setSurveyData(updatedFormData)
     // Make the post request here to save to database
    console.log("HERE")
    console.log(updatedFormData)
    console.log(Object.keys(updatedFormData).length)
    if (Object.keys(updatedFormData).length !== 6) {
      alert("Please enter all fields")
    }
    else {
      axios.post(`${baseUrl}/surveys/freelance`, updatedFormData, {
        headers: {
            Authorization: `Bearer ${token}`, // Ensure `token` contains the valid JWT
            'Content-Type': 'application/json' // This might not be needed if `formData` is already an object
        }
      })
      .then(response => {
        console.log("Survey submitted:", response.data);
      })
      .catch(error => {
        console.error("Error submitting survey:", error);
      });
      navigate('/endpage'); // Navigate to the next step
    }

  };

  const handleBack = () => {
    setSurveyData(formData);
    navigate('/surveypage2'); // Change this to the previous step
  };

  return (
    <Box>
      {/* Top Bar */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Survey Content */}
      <Box padding="20px" maxWidth="1200px" margin="auto">
        <Text fontSize="20px" fontWeight="bold" mt="20px">Freelance Preference Survey</Text>
        <Text color="#6E6E6E" mb="12px" fontStyle="italic">
          Please fill this survey out so that we have a better understanding of how to assist you! :)
        </Text>

        {/* Progress Bar */}
        <Box padding="20px" maxWidth="1150px" margin="auto">
          <ProgressBar step={3} totalSteps={4} />
        </Box>
        <Text fontSize="22px" fontWeight="bold" mt={4} textAlign={'center'}>
        What would be your second choice in what type of freelancing you would want to do?
        </Text>

        {/* Survey Question Component */}
        <SurveyQuestion
          selectedOption={formData.second_choice}
          setSelectedOption={(value) => setFormData({ ...formData, second_choice: value })}
        />

        {/* Navigation Buttons */}
        <Box marginTop="150px">
        <NavigationButtons onNext={handleNext} onBack={handleBack} />
        </Box>

        {/* Navbar at Bottom */}
        <Box marginTop="50px">
          <Navbar />
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyPage3;
